var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraduateCap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.064,
    height: 16.686
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".graduateCap_svg__cls-1{fill:#0a3f6e}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graduateCap_svg__graduate-cap",
    transform: "translate(-2118.362 -448.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graduateCap_svg__Group_36003",
    transform: "translate(2118.362 448.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "graduateCap_svg__Path_232672",
    d: "M2145.425 460.269a1.014 1.014 0 00-.389-.792.517.517 0 01-.187-.412V453.1a.193.193 0 000-.361l-12.741-4.492a1.324 1.324 0 00-.881 0l-12.737 4.493a.192.192 0 000 .361l12.9 5.026a.779.779 0 00.558 0l11.253-4.383a.556.556 0 01.757.518v4.807a.506.506 0 01-.178.407 1.012 1.012 0 00.224 1.737 8.422 8.422 0 00-.621 2.624 1.022 1.022 0 002.044 0 8.451 8.451 0 00-.466-2.221.581.581 0 01.159-.614 1.026 1.026 0 00.305-.733z",
    className: "graduateCap_svg__cls-1",
    transform: "translate(-2118.362 -448.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "graduateCap_svg__Path_232673",
    d: "M2124.052 457.285a.588.588 0 00-.8.548v2.555c0 2.685 4.032 4.871 9.11 5.016h.059c5.077-.145 9.11-2.329 9.11-5.016v-2.555a.588.588 0 00-.8-.548l-7.846 3.056a1.363 1.363 0 01-.985 0z",
    className: "graduateCap_svg__cls-1",
    transform: "translate(-2119.086 -449.515)"
  })))));
}

export default SvgGraduateCap;